import * as React from 'react'
import useSWR from 'swr'

import { UserContext, UserContextData, initialData } from './useUserContext'
import { captureExceptionWithSentry, setSentryUserContext } from '../sentry'

const UserProvider = (props: any) => {
	const { data, error, mutate } = useSWR('/api/users/current', { refreshInterval: 300000 })
	if (error) {
		captureExceptionWithSentry(error)
	}
	const contextData: UserContextData = data?.errorMsg === 'not logged in'
		? { ...initialData, meta: 'not logged in' }
		: data ?? initialData

	if (contextData?.username) {
		setSentryUserContext(contextData.username)
	}

	contextData.refresh = async () => {
		mutate()
	}
	return <UserContext.Provider value={contextData}>{props.children}</UserContext.Provider>
}

export { UserProvider }
